import { red, green, blue, deepPurple } from "@mui/material/colors";
import { UserRole } from "../models/User";

export const getRoleLabel = (role: UserRole): string => {
  const roleLabels: Record<UserRole, string> = {
    [UserRole.SystemAdmin]: "System Admin",
    [UserRole.OrgAdmin]: "Organization Admin",
    [UserRole.Developer]: "Developer",
    [UserRole.Operator]: "Operator",
    [UserRole.Robot]: "Robot",
  };

  return roleLabels[role] || "Unknown Role";
};

export const getRoleColor = (role: UserRole): string => {
  const roleColors: Record<UserRole, string> = {
    [UserRole.SystemAdmin]: red[700],
    [UserRole.OrgAdmin]: green[500],
    [UserRole.Developer]: blue[500],
    [UserRole.Operator]: deepPurple[500],
    [UserRole.Robot]: "#000000", // Default color for Robot role
  };

  return roleColors[role] || "#000000";
};
